import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import { Cookies } from 'react-cookie'
import { useDispatch } from 'react-redux'

import { postFrontUserTokencheck } from 'api'
import { setAuth } from 'store/auth'
import { initCart } from 'store/cart'
import { setWishlist } from 'store/wishlist'

// eslint-disable-next-line react/display-name
const withAuth = (Component) => (props) => {
  const router = useRouter()
  const [check, setCheck] = useState(false)

  const dispatch = useDispatch()

  const cookies = new Cookies()
  const token = cookies.get('token')
  const id = cookies.get('user_id')
  const lang = cookies.get('lang')

  useEffect(() => {
    sessionStorage.setItem('prevPath', router.asPath)

    if (!token) {
      router.push(`${lang ? '/' + lang : ''}/signin`, undefined, {
        shallow: true,
      })
    } else {
      postFrontUserTokencheck(id, token).then((res) => {
        if (res) setCheck(true)
        else {
          cookies.remove('token', { path: '/' })
          cookies.remove('user_id', { path: '/' })
          dispatch(setAuth({ token: null, id: null }))
          dispatch(initCart())
          dispatch(setWishlist({ wishlist: null }))

          router.push('/signin')
        }
      })
    }
  }, [])

  return check ? <Component {...props} /> : null
}

export default withAuth
